import React from 'react';
import styles from '../../Layout/sidebar/sidebar.module.scss';

export default function SocialLinks({ url, icon }) {
  return (
    <a href={`${url}`} className={`${styles.nav_link_bottom} p-1`}>
      <span className={`d-inline ${styles.label}`}>{icon}</span>
    </a>
  );
}
